import { schema } from "normalizr";

const LogInApprovalSchema = new schema.Entity("logInApprovals");
const LogInApprovalArraySchema = new schema.Array(LogInApprovalSchema);

export { LogInApprovalSchema, LogInApprovalArraySchema };